import { css } from 'aphrodite';
import { Button } from '../../../components-v2/Button';
import { formatCurrency } from '../../../pages/AdvancedReporting/helpers/formatCurrency';
import { QuestionMarkIcon } from '../../svgs/icons/QuestionMarkIcon';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../Tooltip';
import { styleSheet } from './styles';

const VOLUNTEER_TIME_VALUE_URL = 'https://independentsector.org/research/value-of-volunteer-time/';

export const formatVolunteerHours = (value: number) => `${value.toFixed(1)}h`;

/** The anchored explanation of where the donated-time-value figure comes from. */
export const DonatedTimeValueHelp = ({ ratePerHour }: { ratePerHour?: number }) => {
	if (!ratePerHour) {
		return null;
	}
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button variant='ghost' size='icon' aria-label='How donated time value is calculated'>
						<QuestionMarkIcon />
					</Button>
				</TooltipTrigger>
				<TooltipContent side='bottom' styles={[styleSheet.content]}>
					Donated time value uses Independent Sector&rsquo;s national estimate of {formatCurrency(ratePerHour)} per
					volunteer hour.{' '}
					<a className={css(styleSheet.link)} href={VOLUNTEER_TIME_VALUE_URL} target='_blank' rel='noreferrer'>
						Learn more
					</a>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};
